// extracted by mini-css-extract-plugin
var _1 = "Element_active__0f23f";
var _2 = "Element_annotation__3923a";
var _3 = "Element_annotationTitle__aed10";
var _4 = "Element_bulletedList__1423e";
var _5 = "Element_caption__617a5";
var _6 = "Element_close__bb14a";
var _7 = "Element_code__0a77f";
var _8 = "Element_elementBlockquote__81ffb";
var _9 = "Element_heading1__d1f4c";
var _a = "Element_heading2__76aef";
var _b = "Element_heading3__52bcd";
var _c = "Element_heading4__b0f61";
var _d = "Element_link__fd868";
var _e = "Element_listItem__af5d0";
var _f = "Element_mobile__d0000";
var _10 = "Element_numberedList__af9f4";
var _11 = "Element_pseudoSelection__74dc0";
var _12 = "Element_textBold__64a5e";
var _13 = "Element_textItalic__8a243";
var _14 = "Element_textStrikethrough__843b1";
var _15 = "Element_textUnderline__7aee2";
export { _1 as "active", _2 as "annotation", _3 as "annotationTitle", _4 as "bulletedList", _5 as "caption", _6 as "close", _7 as "code", _8 as "elementBlockquote", _9 as "heading1", _a as "heading2", _b as "heading3", _c as "heading4", _d as "link", _e as "listItem", _f as "mobile", _10 as "numberedList", _11 as "pseudoSelection", _12 as "textBold", _13 as "textItalic", _14 as "textStrikethrough", _15 as "textUnderline" }
